<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iptal/tahakkuk" type="default"> Mesken Borç İşlem
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iptal/sayac" type="default"> Sayaç İşlem
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iptal/gider" type="default">Gider İşlem
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iptal/gelir" type="default">Gelir İşlem
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iptal/makbuz" type="default">Makbuz İptal
            </router-link>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        SeciliBina: null,
        BinaBilgi: []
      }
    },
    created() {
      //console.log(this.$store.getters.Yetki);
      if (this.$store.getters.Yetki.iptal == '0') this.$router.push("/403");
      if (this.$store.getters.BinaBilgi) {
        this.BinaBilgi = this.$store.getters.BinaBilgi;
        this.SeciliBina = this.BinaBilgi.id;
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iptal/_route.vue